module.exports = __webpack_public_path__ + "static/media/dir-1.3e5f8a37.jpg";